import Review from './Review';
import { ReviewQuery } from './ReviewQuery.graphql';

Review.query = ReviewQuery;

export default Review;
